var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Sidebar,{attrs:{"SidebarData":_setup.SidebarData,"signOutFunction":_setup.logout,"currentUser":_setup.currentUser,"route":_setup.route}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }